/**
 * QuoterUrls - Mapeo centralizado de URLs de productos
 *
 * Evita hardcoding de URLs y facilita cambios futuros.
 * Cuando un usuario hace click en un item del carrito,
 * lo redirige a la página correcta del cotizador.
 *
 * @version 1.0.0
 */

const QuoterUrls = {
  /**
   * URLs de páginas de productos (cotizadores)
   */
  PRODUCT_PAGES: {
    premium: '/pages/premium',
    holografico: '/pages/holografico',
    iman: '/pages/imanes',
    economico: '/pages/economicos',
    sheets: '/pages/sheets-laminadas',
    sheets_economicas: '/pages/sheets-economicas',
  },

  /**
   * URLs del sistema
   */
  CART: '/cart',
  CHECKOUT: '/checkout',
  HOME: '/',

  /**
   * Obtener URL de la página del producto (cotizador)
   * @param {string} producto - ID del producto
   * @returns {string} URL de la página
   */
  getProductPageUrl(producto) {
    const key = this._normalizeKey(producto);
    const url = this.PRODUCT_PAGES[key];

    if (!url) {
      console.warn('[QuoterUrls] URL no encontrada para producto:', producto);
      return this.HOME;
    }

    return url;
  },

  /**
   * Navegar a la página del producto
   * @param {string} producto - ID del producto
   */
  navigateToProduct(producto) {
    const url = this.getProductPageUrl(producto);
    window.location.href = url;
  },

  /**
   * Abrir página del producto en nueva pestaña
   * @param {string} producto - ID del producto
   */
  openProductInNewTab(producto) {
    const url = this.getProductPageUrl(producto);
    window.open(url, '_blank');
  },

  /**
   * Navegar al carrito
   */
  navigateToCart() {
    window.location.href = this.CART;
  },

  /**
   * Navegar al checkout
   */
  navigateToCheckout() {
    window.location.href = this.CHECKOUT;
  },

  /**
   * Verificar si estamos en una página de cotizador
   * @returns {boolean}
   */
  isOnQuoterPage() {
    const path = window.location.pathname;
    return Object.values(this.PRODUCT_PAGES).some(url => path.includes(url));
  },

  /**
   * Obtener el producto actual basado en la URL
   * @returns {string|null} ID del producto o null
   */
  getCurrentProduct() {
    const path = window.location.pathname;

    for (const [producto, url] of Object.entries(this.PRODUCT_PAGES)) {
      if (path.includes(url)) {
        return producto;
      }
    }

    return null;
  },

  /**
   * Construir URL con parámetros (útil para pre-llenar cotizador)
   * @param {string} producto - ID del producto
   * @param {Object} params - Parámetros { ancho, alto, cantidad }
   * @returns {string} URL con query params
   */
  buildProductUrl(producto, params = {}) {
    const baseUrl = this.getProductPageUrl(producto);
    const searchParams = new URLSearchParams();

    if (params.ancho) searchParams.set('ancho', params.ancho);
    if (params.alto) searchParams.set('alto', params.alto);
    if (params.cantidad) searchParams.set('cantidad', params.cantidad);

    const queryString = searchParams.toString();
    return queryString ? baseUrl + '?' + queryString : baseUrl;
  },

  /**
   * Normalizar key del producto (delega a QUOTER_CONFIG.normalizeProductId)
   * @private
   */
  _normalizeKey(producto) {
    if (window.QUOTER_CONFIG) return window.QUOTER_CONFIG.normalizeProductId(producto);
    return producto ? producto.toLowerCase().trim() : 'premium';
  }
};

// Exportar globalmente
if (typeof window !== 'undefined') {
  window.QuoterUrls = QuoterUrls;
}
